import * as TypeGraphQL from "type-graphql";
export var OptionsPositionScalarFieldEnum;
(function (OptionsPositionScalarFieldEnum) {
    OptionsPositionScalarFieldEnum["id"] = "id";
    OptionsPositionScalarFieldEnum["alpacaAccountId"] = "alpacaAccountId";
    OptionsPositionScalarFieldEnum["contractId"] = "contractId";
    OptionsPositionScalarFieldEnum["status"] = "status";
    OptionsPositionScalarFieldEnum["openingSide"] = "openingSide";
    OptionsPositionScalarFieldEnum["quantity"] = "quantity";
    OptionsPositionScalarFieldEnum["entryPrice"] = "entryPrice";
    OptionsPositionScalarFieldEnum["entryCost"] = "entryCost";
    OptionsPositionScalarFieldEnum["entryTime"] = "entryTime";
    OptionsPositionScalarFieldEnum["exitPrice"] = "exitPrice";
    OptionsPositionScalarFieldEnum["exitValue"] = "exitValue";
    OptionsPositionScalarFieldEnum["exitTime"] = "exitTime";
    OptionsPositionScalarFieldEnum["currentPrice"] = "currentPrice";
    OptionsPositionScalarFieldEnum["currentValue"] = "currentValue";
    OptionsPositionScalarFieldEnum["unrealizedPnL"] = "unrealizedPnL";
    OptionsPositionScalarFieldEnum["unrealizedPnLPercent"] = "unrealizedPnLPercent";
    OptionsPositionScalarFieldEnum["realizedPnL"] = "realizedPnL";
    OptionsPositionScalarFieldEnum["realizedPnLPercent"] = "realizedPnLPercent";
    OptionsPositionScalarFieldEnum["totalFees"] = "totalFees";
    OptionsPositionScalarFieldEnum["currentDelta"] = "currentDelta";
    OptionsPositionScalarFieldEnum["currentGamma"] = "currentGamma";
    OptionsPositionScalarFieldEnum["currentTheta"] = "currentTheta";
    OptionsPositionScalarFieldEnum["currentVega"] = "currentVega";
    OptionsPositionScalarFieldEnum["currentRho"] = "currentRho";
    OptionsPositionScalarFieldEnum["currentImpliedVolatility"] = "currentImpliedVolatility";
    OptionsPositionScalarFieldEnum["daysHeld"] = "daysHeld";
    OptionsPositionScalarFieldEnum["exitReason"] = "exitReason";
    OptionsPositionScalarFieldEnum["strategyType"] = "strategyType";
    OptionsPositionScalarFieldEnum["tradeId"] = "tradeId";
    OptionsPositionScalarFieldEnum["metadata"] = "metadata";
    OptionsPositionScalarFieldEnum["createdAt"] = "createdAt";
    OptionsPositionScalarFieldEnum["updatedAt"] = "updatedAt";
})(OptionsPositionScalarFieldEnum || (OptionsPositionScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(OptionsPositionScalarFieldEnum, {
    name: "OptionsPositionScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=OptionsPositionScalarFieldEnum.js.map